// extracted by mini-css-extract-plugin
export default {"header":"ConvertFb2ToEpubDialog__header--3Q7Od","content":"ConvertFb2ToEpubDialog__content--157Sl"};